var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb cmp-product-thumb--modern",
      attrs: {
        "data-testing":
          _vm.item && _vm.item.variation ? _vm.item.variation.id : ""
      }
    },
    [
      _vm.item
        ? _c(
            "div",
            { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
            [
              _c("div", { staticClass: "thumb-content" }, [
                _c(
                  "a",
                  {
                    staticClass: "player-name",
                    attrs: {
                      href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                    },
                    on: {
                      mouseover: function($event) {
                        _vm.showTop5Tooltip =
                          _vm.isTopItem || _vm.isTopInteractions()
                      },
                      mouseleave: function($event) {
                        _vm.showTop5Tooltip = false
                      }
                    }
                  },
                  [
                    (_vm.isTopItem || _vm.isTopInteractions()) &&
                    _vm.showTop5Tooltip
                      ? _c(
                          "span",
                          { staticClass: "custom-tooltip top5-tooltip" },
                          [_vm._v("Top 5 Community Gerücht")]
                        )
                      : _vm._e(),
                    _vm._v("\n        " + _vm._s(_vm._f("itemName")(_vm.item))),
                    _vm.isTopItem || _vm.isTopInteractions()
                      ? _c("span", { staticClass: "trending-text ml-1" }, [
                          _vm._v("🔥")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.probability()
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "probability-info d-flex align-items-center"
                      },
                      [
                        _c("i", { staticClass: "fa fa-refresh" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "probability-value" },
                          [
                            _vm._v(
                              "\n              Unsere Wechseleinschätzung:\n            "
                            ),
                            _vm.probability() === "?"
                              ? [_vm._v(_vm._s(_vm.probability()))]
                              : [_vm._v(_vm._s(_vm.probability()) + "%")]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.progression() === "Steigend"
                          ? _c("i", {
                              staticClass:
                                "fa fa-angle-double-up trend-icon ml-2"
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.progression() === "Fallend"
                          ? _c("i", {
                              staticClass:
                                "fa fa-angle-double-down trend-icon ml-2"
                            })
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.position()
                  ? _c("div", { staticClass: "position-info" }, [
                      _c("i", { staticClass: "fa fa-map-marker" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.position()))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "market-value mb-3" }, [
                  _c("i", { staticClass: "fa fa-eur" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.marketValue()) + " €")])
                ]),
                _vm._v(" "),
                _vm.probability() || (_vm.fromClub() && _vm.toClub())
                  ? _c("div", { staticClass: "info-button-group" }, [
                      _vm.fromClub() && _vm.toClub()
                        ? _c("div", { staticClass: "transfer-box" }, [
                            _c(
                              "div",
                              { staticClass: "transfer-club current" },
                              [
                                _c("span", { staticClass: "club-label" }, [
                                  _vm._v("Aktuell")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "club-name" },
                                  [_vm._t("from-club-name")],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "fa fa-long-arrow-right transfer-arrow"
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "transfer-club target" }, [
                              _c("span", { staticClass: "club-label" }, [
                                _vm._v("Ziel")
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "club-name" },
                                [_vm._t("to-club-name")],
                                2
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item && _vm.isClosed()
                  ? _c("div", { staticClass: "closed-overlay" }, [
                      _c(
                        "a",
                        {
                          staticClass: "closed-message",
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            )
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-lock" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Gerücht geschlossen")])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item && _vm.item.variation
                  ? _c("div", { staticClass: "community-insight-wrapper" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.shouldLoadWidgets,
                              expression: "shouldLoadWidgets"
                            }
                          ],
                          staticClass: "community-insight"
                        },
                        [
                          _c("h3", { staticClass: "insight-title" }, [
                            _vm._v("Fan Feedback")
                          ]),
                          _vm._v(" "),
                          !_vm.isLoggedIn
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "alert alert-warning mb-2 text-center px-0"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "alert-link small py-2 px-3",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { href: "javascript:void(0)" },
                                      on: { click: _vm.openRegisterModal }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-info-circle mr-1"
                                      }),
                                      _vm._v(
                                        "Fan-Konto erstellen & mitbestimmen\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "widget-section" },
                            [
                              _c("vote-widget", {
                                attrs: {
                                  "reference-type": "item",
                                  "reference-id": _vm.item.variation.id,
                                  "show-title": false,
                                  "initial-thumbs-up": _vm.thumbsUpFromProperty(),
                                  "initial-thumbs-down": _vm.thumbsDownFromProperty()
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "widget-divider" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "widget-section" },
                            [
                              _c("rumor-probability-widget", {
                                attrs: {
                                  "variation-id": _vm.item.variation.id,
                                  "show-title": false,
                                  "initial-average-probability": _vm.averageProbabilityFromProperty(),
                                  "initial-count": _vm.probabilityCountFromProperty()
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "widget-divider" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "widget-section" },
                            [
                              _c("team-impact-display", {
                                attrs: {
                                  "reference-type": "item",
                                  "reference-id": _vm.item.variation.id,
                                  "show-title": true,
                                  "item-data": _vm.item,
                                  "initial-rating1": _vm.teamImpactRating1FromProperty(),
                                  "initial-rating2": _vm.teamImpactRating2FromProperty(),
                                  "initial-rating3": _vm.teamImpactRating3FromProperty(),
                                  "initial-rating4": _vm.teamImpactRating4FromProperty(),
                                  "initial-rating5": _vm.teamImpactRating5FromProperty()
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item && _vm.item.variation
                  ? _c("div", { staticClass: "action-button-group" }, [
                      _c(
                        "a",
                        {
                          staticClass: "action-btn lieblings-btn",
                          attrs: {
                            href: _vm._f("itemURL")(
                              _vm.item,
                              _vm.urlWithVariationId
                            )
                          }
                        },
                        [
                          _c("span", [_vm._v("Zum Fanliebling")]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-long-arrow-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "action-btn wishlist-btn-wrapper" },
                        [
                          _c("add-to-wish-list", {
                            attrs: { "variation-id": _vm.item.variation.id }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }